import { apiClient, authFetchBlob, orgApiPath } from '@/core/api';
import type { RenderJobSummary, RenderOutputResolution } from '@/types/api';

export async function listOrganizationRenders(
  params: { offset?: number; limit?: number } = {},
): Promise<RenderJobSummary[]> {
  const { offset = 0, limit = 100 } = params;
  const q = new URLSearchParams({
    offset: String(offset),
    limit: String(limit),
  });
  return apiClient<RenderJobSummary[]>(orgApiPath(`/renders?${q.toString()}`));
}

export async function listCreativeRenders(
  creativeId: number,
  params: { offset?: number; limit?: number } = {},
): Promise<RenderJobSummary[]> {
  const { offset = 0, limit = 50 } = params;
  const q = new URLSearchParams({
    offset: String(offset),
    limit: String(limit),
  });
  return apiClient<RenderJobSummary[]>(
    orgApiPath(`/creatives/${creativeId}/renders?${q.toString()}`),
  );
}

export async function startRenderJob(
  creativeId: number,
  outputResolution: RenderOutputResolution,
  options: { force?: boolean } = {},
): Promise<number> {
  const row = await apiClient<{ id: number | null }>(
    orgApiPath(`/creatives/${creativeId}/render`),
    {
      method: 'POST',
      body: JSON.stringify({
        output_resolution: outputResolution,
        force: options.force ?? false,
      }),
    },
  );
  if (row.id == null) {
    throw new Error('Render job missing id');
  }
  return row.id;
}

export async function downloadRenderOutputFile(
  creativeId: number,
  renderId: number,
  filename: string,
): Promise<void> {
  const blob = await authFetchBlob(
    orgApiPath(`/creatives/${creativeId}/renders/${renderId}/output`),
  );
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename.endsWith('.mp4') ? filename : `${filename}.mp4`;
  a.rel = 'noopener';
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
